import React, { useEffect, useRef } from 'react';
import { howItWorksData } from '../../data/mock';

const HowItWorksSection = () => {
  const stepsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.3 }
    );

    stepsRef.current.forEach((step) => {
      if (step) observer.observe(step);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="how-it-works" className="section-light section-padding">
      <div className="container" style={{ padding: '0 5%' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="section-title section-title-light">
            How it works
          </h2>
        </div>

        {/* Steps Grid */}
        <div 
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '40px',
            position: 'relative',
          }}
        >
          {/* Connection Line */}
          <div 
            style={{
              position: 'absolute',
              top: '60px',
              left: '16.66%',
              right: '16.66%',
              height: '2px',
              background: 'linear-gradient(90deg, transparent, #f06a15, #f06a15, transparent)',
              opacity: 0.3,
              zIndex: 0,
            }}
          />

          {howItWorksData.steps.map((step, i) => (
            <div
              key={i}
              ref={(el) => (stepsRef.current[i] = el)}
              className="stagger-item"
              style={{
                textAlign: 'center',
                position: 'relative',
                zIndex: 1,
                transitionDelay: `${i * 0.2}s`,
              }}
            >
              {/* Step Number */}
              <div 
                style={{
                  width: '120px',
                  height: '120px',
                  margin: '0 auto 30px',
                  background: '#fff',
                  border: '2px solid #f06a15',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  boxShadow: '0 20px 50px rgba(240, 106, 21, 0.15)',
                }}
              >
                <span 
                  style={{
                    fontSize: '48px',
                    fontWeight: 800,
                    color: '#f06a15',
                    opacity: 0.3,
                  }}
                >
                  {step.number}
                </span>
              </div>

              {/* Title */}
              <h3 
                style={{
                  fontSize: '24px',
                  fontWeight: 700,
                  color: '#0a0a0a',
                  marginBottom: '16px',
                }}
              >
                {step.title}
              </h3>

              {/* Content */}
              {step.examples ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {step.examples.map((example, j) => (
                    <span 
                      key={j}
                      style={{
                        fontSize: '14px',
                        color: '#666',
                        fontStyle: 'italic',
                      }}
                    >
                      {example}
                    </span>
                  ))}
                </div>
              ) : (
                <p 
                  style={{
                    fontSize: '16px',
                    color: '#666',
                    lineHeight: 1.6,
                  }}
                >
                  {step.description}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Visual */}
        <div 
          style={{
            marginTop: '80px',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <img 
            src={howItWorksData.image}
            alt="How Naabu Works"
            style={{
              width: '100%',
              height: '400px',
              objectFit: 'cover',
            }}
          />
          {/* Overlay */}
          <div 
            style={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(to right, rgba(255, 255, 255, 0.9), transparent, rgba(255, 255, 255, 0.9))',
            }}
          />
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          #how-it-works > div > div:nth-child(2) {
            grid-template-columns: 1fr !important;
          }
          #how-it-works > div > div:nth-child(2) > div:first-child {
            display: none !important;
          }
        }
      `}</style>
    </section>
  );
};

export default HowItWorksSection;
